import { Pipe, PipeTransform } from '@angular/core';
import { Folder } from 'src/app/models/server/folder';

@Pipe({
    name: 'avmLockedByPipe',
    standalone: true,
    pure: true,
})
export class AvmLockedByPipe implements PipeTransform {
    constructor() {}

    /**
     * Retourne un texte indiquand par quel utilisateur le dossier spécifié est verrouillé.
     * @param folder : Instance du dossier.
     */
    transform(folder: Folder): string {
        //console.count(`AvmLockedByPipe - transform ${folder.id}`);

        return `verrouillé par ${folder['lockedBy']}`;
    }
}
